'use client';

import type { ComponentType } from 'react';
import { useEffect, useState } from 'react';

export const SettingsNavSheet = () => {
  const [Content, setContent] = useState<ComponentType | null>(null);
  const [loadError, setLoadError] = useState<Error>();

  // Primary navigation is part of the global app graph. Load Settings only in
  // the browser so changes cannot reconnect it to the RSC evaluator.
  useEffect(() => {
    let isMounted = true;

    import('./SettingsNavSheetContent')
      .then((module) => {
        if (isMounted) {
          setContent(() => module.SettingsNavSheetContent);
        }
      })
      .catch((error: unknown) => {
        if (isMounted) {
          setLoadError(
            error instanceof Error
              ? error
              : new Error('Unable to load Settings navigation')
          );
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (loadError) {
    throw loadError;
  }

  return Content ? <Content /> : null;
};
